<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <el-form :model="conditions" inline>
        <div class="componentSty_content_title">
          <span class="fonints">计划单号</span>
          <el-input
            placeholder="请输入关键词"
            v-model="conditions.pno"
            clearable
          >
          </el-input>
          <span class="fonints">车牌号码</span>
          <el-input
            placeholder="请输入关键词"
            v-model="conditions.plate"
            clearable
          >
          </el-input>
          <span class="fonints">货主名称</span>
          <el-input
            placeholder="请输入关键词"
            v-model="conditions.customname"
            clearable
          >
          </el-input>
          <el-form-item prop="rfid" class="rfid-field">
            <span class="fonints">rfid卡号 </span>
            <el-input
              style="width: 230px"
              @clear="conditions.rfid = ''"
              placeholder="请输入关键词"
              v-model="conditions.rfid"
              clearable
            >
            </el-input>
          </el-form-item>
        </div>
        <div class="componentSty_content_title">
          <span class="fonints">代理名称</span>
          <el-input
            placeholder="请输入关键词"
            v-model="conditions.agentname"
            clearable
          >
          </el-input>
          <span class="fonints">货场名称</span>
          <div class="select_box">
            <m-select :list="selectastrict" v-model="selectinfo"></m-select>
          </div>
          <button class="buttons" @click="selectlist">查询</button>
          <button class="buttons" style="background: #F5F6FA;color: #17B6A1;" @click="readCard">
            {{ isReading ? "正在读取" : "读卡" }}
          </button>
          <el-tag type="danger" v-if="connState != 1">读卡连接异常。</el-tag>
          <button
            class="buttons"
            style="background: #17B6A1"
            @click="approved(true)"
          >
            审核通过
          </button>
          <button
            class="buttons"
            style="background: #F5F6FA; color: #17B6A1; float: right; margin-right: 20px"
            @click="approved(false)"
          >
            审核不通过
          </button>
        </div>
        <div class="componentSty_content_title">
          <div class="carstatus" v-if="onlyobj">
            车辆状态:
            <span>{{ onlyobj.plate }}</span>
            <span
              style="color: #ef6b60"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 10"
              >待接单</span
            >
            <span
              style="color: #448aff"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 11"
              >待代理确认</span
            >
            <span
              style="color: #448aff"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 20"
              >待缴费</span
            >
            <span
              style="color: #448aff"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 30"
              >待审核</span
            >
            <span
              style="color: #448aff"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 40"
              >待进场</span
            >
            <span
              style="color: #448aff"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 42"
              >进卡口</span
            >
            <span
              style="color: #448aff"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 43"
              >装车</span
            >
            <span
              style="color: #448aff"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 44"
              >回皮</span
            >
            <span
              style="color: #448aff"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 45"
              >过重</span
            >
            <span
              style="color: #448aff"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 46"
              >无作业</span
            >
            <span
              style="color: #b2b2b2"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 49"
              >进场后取消，待审核</span
            >
            <span
              style="color: #b2b2b2"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 50"
              >待出场</span
            >
            <span
              style="color: #b2b2b2"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 60"
              >完成</span
            >
            <span
              style="color: #b2b2b2"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 61"
              >拒绝接单</span
            >
            <span
              style="color: #b2b2b2"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 62"
              >进场前取消</span
            >
            <span
              style="color: #b2b2b2"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 63"
              >进场后取消</span
            >
            <span
              style="color: #b2b2b2"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 64"
              >审核未通过</span
            >
            <span
              style="color: #b2b2b2"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 65"
              >代理拒绝</span
            >
            <span
              style="color: #b2b2b2"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 66"
              >审核前取消</span
            >
            <span
              style="color: #b2b2b2"
              class="el_spanfontstyle"
              v-if="onlyobj.status == 68"
              >取消未通过</span
            >
          </div>
          <button
            class="buttons"
            style="background: #F5F6FA; float: right; margin-right: 20px"
            @click="isshow = true"
          >
            取消全部未审核
          </button>
        </div>
      </el-form>
      <div class="componentSty_content_table" style="top: 135px;border:none">
        <el-table
          ref="multipleTable"
          :data="arrlist.data"
          style="width: 100%; "
          @sort-change="sortchange"
          border
          @selection-change="selChange"
           height="80%"
        >
           <el-table-column show-overflow-tooltip
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column show-overflow-tooltip type="selection"> </el-table-column>
          <el-table-column show-overflow-tooltip
            prop="pno"
            label="计划单号"
            sortable="custom"
          ></el-table-column>
          <el-table-column show-overflow-tooltip prop="shipname" label="船名"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="storename" label="货场名称"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="customname" label="货主名称">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="agentname" label="代理名称"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="custmername" label="流向"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="fleetname" label="代理名称"> </el-table-column>
          <el-table-column show-overflow-tooltip prop="plate" label="车牌号"> </el-table-column>
          <el-table-column show-overflow-tooltip label="计划吨数">
            <template v-slot="res">
              <span>{{ res.row.plantons }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="操作">
            <template v-slot="res">
              <span
                @click="iteminfofun(res.row)"
                class="iconfont icon-chakan"
              ></span>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginations" v-show="arrlist.data && arrlist.data.length">
          <el-pagination
            :page-size="conditions.limit"
            layout="total,prev, pager,next, jumper"
            :total="arrlist.count"
            :current-page="conditions.page"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <pdialog
      :isshowdialog="isshow"
      :againshow="again"
      :infomsgMsg="infomsg"
      @closedialog="closedialog"
    ></pdialog>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import mSelect from "@/components/mSelect";
import { mapMutations, mapState } from "vuex";
import { antiShake, readRFIDcard_new } from "@/plugins/other.js";
import pdialog from "@/components/pdialog.vue";
export default {
  data() {
    return {
      connState: 1,
      isReading: false, //读卡状态 。
      selectastrict: [],
      onlyobj: null,
      listitem: [{ name: "审核管理" }, { name: "线下审核" }],
      selectinfo: "全部",
      conditions: {
        page: 1,
        limit: 20,
        rfid: "",
        storename: "",
      },
      arrlist: [],
      ids: [],
      platelist: [],
      idcard: "",
      isshow: false,
      clickindex: 1,
      infomsg: "是否取消全部未审核?",
      again: true,
      timeout: null,
    };
  },
  computed: {
    ...mapState(["conditionsList"]),
  },
  watch: {
    // idcard(val) {
    //   // if (val == "读卡器打开成功!" || val === "读卡器连接异常!") return "";
    //   if (val) {
    //     this.conditions.rfid = val;
    //     this.getarrlist("check");
    //   } else {
    //     this.conditions.rfid = "";
    //   }
    // },
  },
  created() {
    // this.conditionsList[this.$route.path] ||
    //   this.createConditions({ key: this.$route.path });
    // this.conditions = this.conditionsList[this.$route.path] || {
    //   page: 1,
    //   limit: 20,
    //   rfid: ''
    // };

    // console.log(this.conditions)
    this.getarrlist();
    this.getselectastrict();
  },
  // mounted() {
  //   this.conditions.rfid = "";
  // },
  components: {
    mTitle,
    mSelect,
    pdialog,
  },
  methods: {
    ...mapMutations(["createConditions", "addnavigationMsg"]),
    // fn_rfid_clear() {
    //   console.log('clear rfid.')
    //   this.idcard=""
    //   this.$nextTick(() => {
    //   console.log('clear rfid.2222')
    //     // this.conditions.rfid = null;
    //    this.idcard = null
    //   })
    // },
    async getarrlist(val) {
      typeof val === "number" && (this.conditions.page = val);
      this.selectinfo == "全部"
        ? (this.conditions.storename = null)
        : (this.conditions.storename = this.selectinfo);
      for (var i in this.conditions) {
        if (!this.conditions[i]) this.conditions[i] = null;
      }
      const { data } = await this.$http(
        "api1",
        "/driver/dispatchtruck/offlinePaymentCheckPendingList",
        "post",
        this.conditions
      );
      if (!data.data) return;
      this.arrlist = data;
      if (Array.isArray(data.truckEntityDto) && data.truckEntityDto[0]) {
        this.onlyobj = data.truckEntityDto[0];
      } else {
        this.onlyobj = null;
      }
      val === "check" &&
        this.$nextTick((_) => {
          data.data[0] &&
            this.$refs.multipleTable.toggleRowSelection(data.data[0], true);
        });
    },
    async getselectastrict() {
      const { data } = await this.$http("api1", "/sys/dic/list", "get", {
        dictionaryType: "货场",
      });
      if (!data.data) return;
      this.selectastrict = ["全部"];
      data.data.forEach((item) => {
        this.selectastrict.push(item.val);
      });
    },
    // 取消全部未审核
    async closedialog(res) {
      if (res == "cancel") {
        this.infomsg = "是否取消全部未审核?";
        this.again = true;
        this.clickindex = 1;
        this.isshow = false;
        return "";
      }
      ++this.clickindex;
      if (this.clickindex == 2) {
        this.infomsg = "请再次确认!";
        this.again = false;
      }
      if (this.clickindex > 2) {
        const { data } = await this.$http(
          "api1",
          "/driver/dispatchtruck/cancelOfflineSendACar",
          "post",
          {}
        );
        if (data.code != 0) return this.$message.error(data.msg);
        this.$message.success("取消全部未审核成功");
        this.infomsg = "是否取消全部未审核?";
        this.again = true;
        this.clickindex = 1;
        this.isshow = false;
      }
    },
    selectlist() {
      antiShake((_) => {
        this.conditions.page = 1;
        this.getarrlist();
      });
    },
    async readCard() {
      // antiShake((_) => {
      //   this.idcard="";
      //   this.conditions.page = 1;
      //   wsReadCard.call(this);
      // });
      // try {
      //   if (this.isReading) {
      //     return;
      //   }
      //   this.isReading = true;
      //   this.conditions.page = 1;
      //   const conn = await getConnection();
      //   const getData = ({ data }) => {
      //     conn.onmessage = null;
      //     this.conditions.rfid = data.toLocaleLowerCase();
      //     this.isReading = false;
      //     this.getarrlist("check");
      //   };
      //   conn.onmessage = getData;
      //   this.connState = conn.readyState;
      //   const setConnState = () => {
      //     this.connState = conn.readyState;
      //     this.isReading = false;
      //   };
      //   conn.onclose = setConnState;
      //   conn.onerror = setConnState;
      // } catch (error) {
      //   this.isReading = false;
      //   console.log("error", error);
      // }
      try {
        if (this.isReading) {
          return;
        }
        this.isReading = true;
        // this.idcard = "";
        this.conditions.page = 1;
        const res = await readRFIDcard_new();
        this.isReading = false;
        if (res.length > 1) {
          this.$message.warning("读取到多个标签。");
        }
        if (res.length == 0) {
          this.$message.error("未读取到标签。");
          this.conditions.rfid = "";
          return;
        }
        this.conditions.rfid = res[0].epc.toLocaleLowerCase();
        this.getarrlist("check");
      } catch (error) {
        this.isReading = false;
        console.log("error", error);
      }
    },
    sortchange(event) {
      if (event.order == "ascending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "asc";
      } else if (event.order == "descending") {
        this.conditions.sidx = event.prop;
        this.conditions.order = "desc";
      } else {
        this.conditions.sidx = "";
        this.conditions.order = "";
      }
      this.getarrlist();
    },
    selChange(event) {
      this.ids = [];
      this.platelist = [];
      event.forEach((item) => {
        this.ids.push(item.id);
        this.platelist.push(item.plate);
      });
    },
    handleCurrentChange(index) {
      if (this.arrlist.count < this.conditions.limit) return;
      this.conditions.page = index;
      this.getarrlist();
    },
    approved(info) {
      if (!this.ids.length) return "";
      if (this.ids.length > 1)
        return this.$message.info("当前只允许通过单条数据");
      var path = "",
        title = "",
        successifo = "";
      if (info) {
        path = "/driver/dispatchtruck/offlinePaymentPassTheAudit";
        title = "是否通过";
        successifo = "审核已通过";
      } else {
        title = "是否不通过";
        path = "/driver/dispatchtruck/offlinePaymentDidNotPassTheAudit";
        successifo = "操作成功";
      }
      this.$messageBox
        .confirm(`${title}?`, `${this.platelist + "" || "提示"}`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          const { data } = await this.$http("api1", path, "post", {
            ids: this.ids,
          });
          if (data.code == 500) return this.$message.error(data.msg);
          this.$message.success(successifo);
          this.conditions.page = 1;
          this.conditions.plate = null;
          this.conditions.customname = null;
          this.idcard = null;
          this.conditions.rfid = null;
          this.conditions.agentname = null;
          this.getarrlist();
        })
        .catch((err) => err);
    },
    iteminfofun(obj) {
      this.addnavigationMsg([
        { name: "审核管理" },
        { name: "线下审核", path: "/audit/awaitaudit" },
        { name: "详情" },
      ]);
      this.$router.push("/audit/infomsg/" + obj.id);
    },
  },
  // beforeDestroy() {
  //   window.ws && window.ws.close();
  //   window.ws = null;
  // },
};
</script>
<style lang="scss">
.componentSty_content_title .rfid-field {
  padding-top: 4px;
}
.carstatus {
  display: inline-block;
  margin-left: 10px;
  font-size: 16px;
  span {
    margin: 0 5px;
  }
}
</style>
<style lang="scss" src="@/assets/components.scss" scoped></style>
